import React from 'react';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { Button, Link, Type, NerdWalletLogo, Text } from '@nerdwallet/currency';
import classes from '@nerdwallet/base-styles/classes';
import {
  elementInteraction,
  ElementImpression,
} from '@nerdwallet/nw-client-lib/tracking';
import {
  setTrk,
  TrkTag,
  TrkMode,
  TrkElement,
} from '@nerdwallet/nw-client-lib/trk-helper';

const Option = (props) => (
  <div className={classes('text-align-center flex-1')}>
    <ElementImpression
      id={get(props, 'id')}
      elementName={get(props, 'name')}
      elementPosition={props.position}
      sectionCategory="interstitial-other-investing-advisors"
    >
      <div>
        <Link
          unstyled
          href={setTrk({
            url: get(props, 'product.details.nw_review_url.value'),
            params: {
              [TrkTag.element]: TrkElement.banner,
              [TrkTag.mode]: TrkMode.redirect,
              [TrkTag.location]: 'interstitial-inv-advisor',
            },
          })}
        >
          <img
            src={get(props, 'product.institution.details.logo_url.value')}
            width="50%"
            alt="logo"
          />
        </Link>
        <Button
          href={setTrk({
            url: get(props, 'product.details.nw_review_url.value'),
            params: {
              [TrkTag.element]: TrkElement.button,
              [TrkTag.mode]: TrkMode.redirect,
              [TrkTag.location]: 'interstitial-inv-advisor',
            },
          })}
          className={classes('margin-vertical-2')}
        >
          Read full review
        </Button>
      </div>
    </ElementImpression>
  </div>
);

Option.propTypes = {
  position: PropTypes.number,
  // eslint-disable-next-line react/no-unused-prop-types -- directive added automatically by Shepherd migration
  logo: PropTypes.string,
  // eslint-disable-next-line react/no-unused-prop-types -- directive added automatically by Shepherd migration
  rating: PropTypes.number,
  // eslint-disable-next-line react/no-unused-prop-types -- directive added automatically by Shepherd migration
  review: PropTypes.string,
  // eslint-disable-next-line react/no-unused-prop-types -- directive added automatically by Shepherd migration
  name: PropTypes.string,
};

const OtherOptions = (props) => (
  <div>
    <div
      className={classes([
        'border-neutral-light',
        'border-bottom-1',
        'padding-top-3',
        'margin-bottom-3',
      ])}
    />
    <Text small bold className={classes('text-align-center')}>
      People also considered
    </Text>
    <div
      className={classes([
        'margin-top-2',
        'display-flex',
        'align-items-baseline',
        'justify-content-space-between',
      ])}
    >
      {props.otherOptions &&
        props.otherOptions.map((optionProps, i) => (
          <Option key={optionProps.name} {...optionProps} position={i} />
        ))}
    </div>
  </div>
);

OtherOptions.propTypes = {
  otherOptions: PropTypes.arrayOf(PropTypes.shape(Option.propTypes)),
};

const AdvisorContent = ({
  tradeName,
  showOtherOptions,
  href,
  ...otherProps
}) => {
  let buttonCTA;
  if (tradeName === 'Merrill Edge') {
    buttonCTA = 'Go to Merrilledge.com';
  } else {
    buttonCTA = tradeName ? `Go to ${tradeName}` : 'Get Started';
  }

  return (
    <div className="primary">
      <div className={classes('margin-vertical-2')}>
        <NerdWalletLogo small />
      </div>
      <Type bold size={4} color="green">
        {showOtherOptions ? "Let's get started." : 'Get excited!'}
      </Type>
      <Type bold size={4}>
        You&apos;re taking a step towards owning your financial future.
      </Type>
      <div className={classes('text-align-center')}>
        <ElementImpression
          id="investing-advisor-main-cta"
          elementName={`investing-advisor-main-cta-${
            showOtherOptions ? 'nonpartner' : 'partner'
          }`}
          sectionCategory="interstitial-investing-advisors-main"
        >
          <Button
            className={classes(['margin-vertical-3', 'display-inline-block'])}
            primary
            href={href}
            onClick={(e) => {
              // When JavaScript is enabled, we want to fire a tracking event and
              // give it enought time to be sent out. So, we'll prevent the
              // browser from immediately taking the user to the new page. If
              // this component is SSRed and shown to a client with JS disabled,
              // the href attribute will immediately take the user to the redirect.
              e.preventDefault();

              const name = `investing-advisor-main-cta-${
                showOtherOptions ? 'nonpartner' : 'partner'
              }`;
              elementInteraction({
                interactionType: 'CLICK',
                elementName: name,
                sectionCategory: 'interstitial-investing-advisors-main',
              });
              // Delay final redirect to ensure enough time for tracking to be sent out
              setTimeout(() => {
                window.location.href = href;
              }, 450);
            }}
          >
            {buttonCTA}
          </Button>
        </ElementImpression>
      </div>
      {tradeName !== 'Merrill Edge' && showOtherOptions && (
        <OtherOptions {...otherProps} />
      )}
    </div>
  );
};

AdvisorContent.propTypes = {
  tradeName: PropTypes.string,
  showOtherOptions: PropTypes.bool,
  href: PropTypes.string,
};

export default AdvisorContent;
